import React from 'react';

export const Step1Icon = () => {
    return (
        <svg width="47" height="54" viewBox="0 0 47 54">
            <g id="Group_279" data-name="Group 279" transform="translate(-615 -575)">
                <g
                    id="Ellipse_101"
                    data-name="Ellipse 101"
                    transform="translate(615 622)"
                    fill="#fff"
                    stroke="#6da3fa"
                    strokeWidth="2"
                >
                    <circle cx="3.5" cy="3.5" r="3.5" stroke="none" />
                    <circle cx="3.5" cy="3.5" r="2.5" fill="none" />
                </g>
                <g
                    id="Ellipse_102"
                    data-name="Ellipse 102"
                    transform="translate(622 611)"
                    fill="#fff"
                    stroke="#6da3fa"
                    strokeWidth="2"
                >
                    <circle cx="7.5" cy="7.5" r="7.5" stroke="none" />
                    <circle cx="7.5" cy="7.5" r="6.5" fill="none" />
                </g>
                <g
                    id="Ellipse_103"
                    data-name="Ellipse 103"
                    transform="translate(625 575)"
                    fill="#fff"
                    stroke="#6da3fa"
                    strokeWidth="2"
                >
                    <circle cx="18.5" cy="18.5" r="18.5" stroke="none" />
                    <circle cx="18.5" cy="18.5" r="17.5" fill="none" />
                </g>
            </g>
        </svg>
    );
};

export const Step2Icon = () => {
    return (
        <svg width="70.584" height="34.813" viewBox="0 0 70.584 34.813">
            <g id="Group_390" data-name="Group 390" transform="translate(-775.949 -584.668)">
                <g
                    id="Group_51"
                    data-name="Group 51"
                    transform="translate(775.949 584.668)"
                    opacity="0.761"
                >
                    <path
                        id="Path_44"
                        data-name="Path 44"
                        d="M0,0V34.813H70.584V0ZM14.117,1.765a1.667,1.667,0,0,1,1.765,1.765,1.667,1.667,0,0,1-1.765,1.765,1.667,1.667,0,0,1-1.765-1.765A1.667,1.667,0,0,1,14.117,1.765Zm-5.294,0a1.667,1.667,0,0,1,1.765,1.765A1.667,1.667,0,0,1,8.823,5.294,1.667,1.667,0,0,1,7.058,3.529,1.667,1.667,0,0,1,8.823,1.765Zm-5.294,0A1.667,1.667,0,0,1,5.294,3.529,1.667,1.667,0,0,1,3.529,5.294,1.667,1.667,0,0,1,1.765,3.529,1.667,1.667,0,0,1,3.529,1.765ZM68.82,33.049H1.765V7.058H68.82Z"
                        fill="#6da3fa"
                    />
                    <rect
                        id="Rectangle_7"
                        data-name="Rectangle 7"
                        width="24.704"
                        height="1.765"
                        transform="translate(22.94 21.175)"
                        fill="#6da3fa"
                    />
                    <rect
                        id="Rectangle_8"
                        data-name="Rectangle 8"
                        width="28.234"
                        height="1.765"
                        transform="translate(22.94 17.646)"
                        fill="#6da3fa"
                    />
                    <rect
                        id="Rectangle_9"
                        data-name="Rectangle 9"
                        width="15.881"
                        height="3.529"
                        transform="translate(22.94 12.352)"
                        fill="#6da3fa"
                    />
                    <rect
                        id="Rectangle_12"
                        data-name="Rectangle 12"
                        width="28.234"
                        height="1.765"
                        transform="translate(22.94 24.704)"
                        fill="#6da3fa"
                    />
                    <path
                        id="Path_45"
                        data-name="Path 45"
                        d="M6.147,19.529V17.588a1.667,1.667,0,0,1,1.765-1.765h5.294a1.667,1.667,0,0,1,1.765,1.765v1.941A7.046,7.046,0,1,0,3.5,14.058,6.859,6.859,0,0,0,6.147,19.529ZM10.558,8.765a2.714,2.714,0,0,1,2.647,2.647,2.714,2.714,0,0,1-2.647,2.647,2.714,2.714,0,0,1-2.647-2.647A2.714,2.714,0,0,1,10.558,8.765Z"
                        transform="translate(2.676 5.352)"
                        fill="#6da3fa"
                    />
                </g>
            </g>
        </svg>
    );
};

export const Step3Icon = () => {
    return (
        <svg width="59.279" height="59.28" viewBox="0 0 59.279 59.28">
            <g id="Group_101" data-name="Group 101" transform="translate(1 1)">
                <path
                    id="Path_36"
                    data-name="Path 36"
                    d="M40.819,52.638h0A6.839,6.839,0,0,1,34,45.819h0A6.839,6.839,0,0,1,40.819,39h0a6.839,6.839,0,0,1,6.819,6.819h0A6.839,6.839,0,0,1,40.819,52.638Z"
                    transform="translate(-12.179 -13.77)"
                    fill="none"
                    stroke="#77a9fa"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_37"
                    data-name="Path 37"
                    d="M51.64,74.351V79.67H23V74.351A8.266,8.266,0,0,1,30.637,66.1a9.729,9.729,0,0,0,6.683,2.728A9.553,9.553,0,0,0,44,66.1,8.266,8.266,0,0,1,51.64,74.351Z"
                    transform="translate(-8.68 -22.39)"
                    fill="none"
                    stroke="#77a9fa"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_38"
                    data-name="Path 38"
                    d="M67.455,55.91h0A5.471,5.471,0,0,1,62,50.455h0A5.471,5.471,0,0,1,67.455,45h0a5.471,5.471,0,0,1,5.455,5.455h0A5.471,5.471,0,0,1,67.455,55.91Z"
                    transform="translate(-21.086 -15.678)"
                    fill="none"
                    stroke="#77a9fa"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_39"
                    data-name="Path 39"
                    d="M70,70.046A6.323,6.323,0,0,0,74.773,68h.682a5.471,5.471,0,0,1,5.455,5.455v4.091H70"
                    transform="translate(-23.631 -22.994)"
                    fill="none"
                    stroke="#77a9fa"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_40"
                    data-name="Path 40"
                    d="M15.455,55.91h0a5.471,5.471,0,0,0,5.455-5.455h0A5.471,5.471,0,0,0,15.455,45h0A5.471,5.471,0,0,0,10,50.455h0A5.471,5.471,0,0,0,15.455,55.91Z"
                    transform="translate(-4.545 -15.678)"
                    fill="none"
                    stroke="#77a9fa"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_41"
                    data-name="Path 41"
                    d="M12.91,70.046A6.323,6.323,0,0,1,8.137,68H7.455A5.471,5.471,0,0,0,2,73.455v4.091H12.91"
                    transform="translate(-2 -22.994)"
                    fill="none"
                    stroke="#77a9fa"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_42"
                    data-name="Path 42"
                    d="M2,22.364V28.5a1.368,1.368,0,0,0,1.364,1.364H7.455L9.5,33.274l1.637-3.41h4.5A1.368,1.368,0,0,0,17,28.5V22.364A1.368,1.368,0,0,0,15.638,21H3.364A1.368,1.368,0,0,0,2,22.364Z"
                    transform="translate(-2 -8.044)"
                    fill="none"
                    stroke="#77a9fa"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_43"
                    data-name="Path 43"
                    d="M32,3.364v14.32a1.368,1.368,0,0,0,1.364,1.364H45.638l2.046,4.773,2.728-4.773H57.23a1.368,1.368,0,0,0,1.364-1.364V3.364A1.368,1.368,0,0,0,57.23,2H33.364A1.368,1.368,0,0,0,32,3.364Z"
                    transform="translate(-11.543 -2)"
                    fill="none"
                    stroke="#77a9fa"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <line
                    id="Line_2"
                    data-name="Line 2"
                    x2="15.002"
                    transform="translate(25.912 5.455)"
                    fill="none"
                    stroke="#77a9fa"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <line
                    id="Line_3"
                    data-name="Line 3"
                    x2="9.547"
                    transform="translate(25.912 10.91)"
                    fill="none"
                    stroke="#77a9fa"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
            </g>
        </svg>
    );
};

export const Step4Icon = () => {
    return (
        <svg width="52.441" height="56.589" viewBox="0 0 52.441 56.589">
            <path
                id="Path_81"
                data-name="Path 81"
                d="M52.382,10.087a2.36,2.36,0,0,0-1.121-1.433L35.814.121A1.532,1.532,0,0,0,34.755.059l-22.8,8.658a9.45,9.45,0,0,0-3.3,2.491l-.125.125-7.1,9.53-.062.062a8.162,8.162,0,0,0-.747,7.661A58.579,58.579,0,0,0,3.3,33.943l.934,1.869a12.672,12.672,0,0,0,19.5,16.195,12.281,12.281,0,0,0,2.927-8.16,5.358,5.358,0,0,0-.062-1L39.3,36.31a8.3,8.3,0,0,0,3.239-2.8c.062-.062.062-.062.062-.125,1.682-3.177,4.734-10.153,9.405-21.489A2.083,2.083,0,0,0,52.382,10.087ZM14.512,27.4l4.8-4.8,6.353.934-3.8,6.6L18.5,31.95a12.245,12.245,0,0,0-1.993-.623Zm-.5,26.659a10.218,10.218,0,1,1-.5-20.43h.5a8.348,8.348,0,0,1,1.246.062l-1.619.872a7.335,7.335,0,0,0-3.862,4.422,7.134,7.134,0,0,0,.5,5.419,6.214,6.214,0,0,0,3.488,3.052,6.523,6.523,0,0,0,1.869.311,5.955,5.955,0,0,0,2.741-.685l5.793-2.99A10.2,10.2,0,0,1,14.013,54.061Zm35.753-43.1c-4.609,11.149-7.6,18.063-9.281,21.177a7.127,7.127,0,0,1-2.3,1.993L17.252,44.905a3.635,3.635,0,0,1-2.678.249,3.686,3.686,0,0,1-2.118-1.869,4.517,4.517,0,0,1-.311-3.488,5.159,5.159,0,0,1,2.616-2.99l8.658-4.547a1.275,1.275,0,0,0,.5-.5l4.858-8.533a1.208,1.208,0,0,0-.436-1.682,4.291,4.291,0,0,0-.5-.187l-8.782-1.246h-.187a1.23,1.23,0,0,0-.872.374l-5.855,5.855a1.229,1.229,0,0,0-.187,1.433L13.7,31.2a12.439,12.439,0,0,0-7.474,2.678l-.561-1.121c-1.183-2.242-2.242-4.235-2.554-5.108a5.531,5.531,0,0,1,.5-5.294l6.976-9.468a8.735,8.735,0,0,1,2.18-1.806h.125L35.128,2.613l14.762,8.16C49.828,10.834,49.828,10.9,49.766,10.959Z"
                transform="translate(0.003 0.009)"
                fill="#77a9fa"
            />
        </svg>
    );
};

export const Step5Icon = () => {
    return (
        <svg width="66.876" height="45.852" viewBox="0 0 66.876 45.852">
            <path
                id="Path_2"
                data-name="Path 2"
                d="M70.6,20.348,39.317,52.083,21.182,33.5a4.8,4.8,0,0,0-7.027,0,4.8,4.8,0,0,0,0,7.027L35.917,62.738h0a4.955,4.955,0,0,0,1.133.68l.453.453a7.007,7.007,0,0,0,1.813.453,4.27,4.27,0,0,0,1.813-.453c.227-.227.453-.227.68-.453.453-.227.68-.453,1.133-.68h0L77.853,27.375a5.132,5.132,0,1,0-7.027-7.481A.791.791,0,0,1,70.6,20.348Z"
                transform="translate(-12.626 -18.473)"
                fill="#77a9fa"
            />
        </svg>
    );
};

export const LogoIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="754.525"
            height="170.938"
            viewBox="0 0 754.525 170.938"
        >
            <g id="Groupe_4" data-name="Groupe 4" transform="translate(-54.805 -37.51)">
                <path
                    id="Path_159"
                    data-name="Path 159"
                    d="M173.3,241.006l43.471,65.378L307,161.01"
                    transform="translate(-110 -115)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeWidth="17"
                />
                <path
                    id="Tracé_1"
                    data-name="Tracé 1"
                    d="M268.658,312.144l44.578-77.138c1.863-4.123,5.187-6.65,9.842-6.65h.8c4.655,0,7.847,2.527,9.709,6.65l34.579,77.138a7.117,7.117,0,0,1,.931,3.458,7.666,7.666,0,0,1-7.714,7.846c-3.857,0-6.517-2.26-7.98-5.719l-7.581-17.422H294.6l-10.847,17.955c-1.33,3.324-5.123,5.186-8.581,5.186a7.493,7.493,0,0,1-7.58-7.581A8.374,8.374,0,0,1,268.658,312.144Zm70.911-26.333-16.358-37.638-21.358,37.638Z"
                    transform="translate(-110 -115)"
                    fill="#fff"
                />
                <path
                    id="Tracé_2"
                    data-name="Tracé 2"
                    d="M396.786,237.134a8.179,8.179,0,0,1,16.358,0v70.754H455.3a7.447,7.447,0,0,1,0,14.895H405.031a8.119,8.119,0,0,1-8.245-8.246Z"
                    transform="translate(-110 -115)"
                    fill="#fff"
                />
                <path
                    id="Tracé_3"
                    data-name="Tracé 3"
                    d="M490.042,237.134a8.179,8.179,0,0,1,16.358,0v78.2a8.179,8.179,0,0,1-16.358,0Z"
                    transform="translate(-110 -115)"
                    fill="#fff"
                />
                <path
                    id="Tracé_4"
                    data-name="Tracé 4"
                    d="M541.27,237.932a8.119,8.119,0,0,1,8.246-8.245h26.466c29.259,0,49.474,20.082,49.474,46.282v.266c0,26.2-20.215,46.548-49.474,46.548H549.516a8.12,8.12,0,0,1-8.246-8.246Zm34.712,69.956c19.55,0,32.318-13.167,32.318-31.387v-.266c0-18.221-12.768-31.653-32.318-31.653H557.628v63.306Z"
                    transform="translate(-110 -115)"
                    fill="#fff"
                />
                <path
                    id="Tracé_5"
                    data-name="Tracé 5"
                    d="M645.3,312.144l34.578-77.138c1.862-4.123,5.187-6.65,9.842-6.65h.8c4.655,0,7.847,2.527,9.709,6.65l34.579,77.138a7.117,7.117,0,0,1,.931,3.458,7.667,7.667,0,0,1-7.715,7.846c-3.856,0-6.515-2.26-7.979-5.719l-7.581-17.422H667.247L659.4,318.262a7.868,7.868,0,0,1-7.581,5.186,7.493,7.493,0,0,1-7.58-7.581A8.374,8.374,0,0,1,645.3,312.144Zm60.912-26.333-16.359-37.638L673.5,285.811Z"
                    transform="translate(-110 -115)"
                    fill="#fff"
                />
                <path
                    id="Tracé_6"
                    data-name="Tracé 6"
                    d="M775.668,244.848H753.059a7.581,7.581,0,1,1,0-15.161H814.9a7.582,7.582,0,0,1,0,15.161H792.159v70.488a8.247,8.247,0,0,1-16.491,0Z"
                    transform="translate(-110 -115)"
                    fill="#fff"
                />
                <path
                    id="Tracé_7"
                    data-name="Tracé 7"
                    d="M848.976,314.537v-76.6a8.119,8.119,0,0,1,8.245-8.245h54.13A7.379,7.379,0,0,1,918.665,237a7.293,7.293,0,0,1-7.314,7.315H865.334v24.205h40.031a7.409,7.409,0,0,1,7.315,7.448,7.266,7.266,0,0,1-7.315,7.181H865.334v25h46.682a7.379,7.379,0,0,1,7.314,7.315,7.292,7.292,0,0,1-7.314,7.314H857.221A8.119,8.119,0,0,1,848.976,314.537Z"
                    transform="translate(-110 -115)"
                    fill="#fff"
                />
            </g>
        </svg>
    );
};

export const PublicFeedIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36.422"
            height="18.149"
            viewBox="0 0 36.422 18.149"
        >
            <g id="Groupe_597" data-name="Groupe 597" transform="translate(-110.385 -559.203)">
                <path
                    id="Tracé_169"
                    data-name="Tracé 169"
                    d="M7.213,0a3.816,3.816,0,0,1,3.809,3.854A3.888,3.888,0,0,1,9.275,7.081a7.265,7.265,0,0,1,5.2,6.184c.09.807-1.255.851-1.344.134a5.978,5.978,0,0,0-11.876,0c-.09.717-1.434.672-1.344-.134A7.376,7.376,0,0,1,5.152,7.081,3.835,3.835,0,0,1,7.213,0Zm0,1.344a2.487,2.487,0,1,0,2.465,2.51A2.505,2.505,0,0,0,7.213,1.344Z"
                    transform="translate(121.405 563.194)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="0"
                />
                <path
                    id="Tracé_169-2"
                    data-name="Tracé 169"
                    d="M5.733,0A3.043,3.043,0,0,1,8.77,3.073,3.1,3.1,0,0,1,7.377,5.646a5.793,5.793,0,0,1,4.145,4.932c.071.643-1,.679-1.072.107a4.767,4.767,0,0,0-9.47,0c-.071.572-1.144.536-1.072-.107A5.882,5.882,0,0,1,4.089,5.646,3.058,3.058,0,0,1,5.733,0Zm0,1.072a1.983,1.983,0,1,0,1.965,2A2,2,0,0,0,5.733,1.072Z"
                    transform="translate(110.881 559.603)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="0"
                />
                <path
                    id="Tracé_169-3"
                    data-name="Tracé 169"
                    d="M5.733,0A3.043,3.043,0,0,1,8.77,3.073,3.1,3.1,0,0,1,7.377,5.646a5.793,5.793,0,0,1,4.145,4.932c.071.643-1,.679-1.072.107a4.767,4.767,0,0,0-9.47,0c-.071.572-1.144.536-1.072-.107A5.882,5.882,0,0,1,4.089,5.646,3.058,3.058,0,0,1,5.733,0Zm0,1.072a1.983,1.983,0,1,0,1.965,2A2,2,0,0,0,5.733,1.072Z"
                    transform="translate(134.881 559.603)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="0"
                />
            </g>
        </svg>
    );
};

export const YourPostsIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17.578"
            height="16.796"
            viewBox="0 0 17.578 16.796"
        >
            <g id="Groupe_582" data-name="Groupe 582" transform="translate(0.346 0.25)">
                <path
                    id="Tracé_169"
                    data-name="Tracé 169"
                    d="M8.469,0a4.471,4.471,0,0,1,4.464,4.516A4.556,4.556,0,0,1,10.884,8.3a8.513,8.513,0,0,1,6.091,7.247c.105.945-1.47,1-1.575.158a7,7,0,0,0-13.916,0c-.105.84-1.68.788-1.575-.158A8.643,8.643,0,0,1,6.053,8.3,4.494,4.494,0,0,1,8.469,0Zm0,1.575a2.915,2.915,0,1,0,2.888,2.941A2.936,2.936,0,0,0,8.469,1.575Z"
                    transform="translate(0)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="0"
                />
            </g>
        </svg>
    );
};

export const PendingPostIcon = () => {
    return (
        <svg width="19.104" height="20.901" viewBox="0 0 19.104 20.901">
            <g id="Group_352" data-name="Group 352" transform="translate(-16.76 -13.464)">
                <path
                    id="Path_124"
                    data-name="Path 124"
                    d="M41.844,44.993a.622.622,0,0,1-.5-.984l1.686-2.351V38.372a.621.621,0,0,1,1.242,0v3.486a.616.616,0,0,1-.116.362l-1.8,2.513A.62.62,0,0,1,41.844,44.993Z"
                    transform="translate(-17.304 -17.21)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="0"
                />
                <path
                    id="Path_125"
                    data-name="Path 125"
                    d="M17.943,18.819a.621.621,0,0,1-.505-.982,9.668,9.668,0,0,1,5.746-3.842.621.621,0,1,1,.271,1.212,8.426,8.426,0,0,0-5.006,3.352A.621.621,0,0,1,17.943,18.819Z"
                    transform="translate(0 0)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="0"
                />
                <path
                    id="Path_126"
                    data-name="Path 126"
                    d="M64.7,18.821a.62.62,0,0,1-.506-.26,8.417,8.417,0,0,0-5.006-3.352A.621.621,0,1,1,59.459,14,9.651,9.651,0,0,1,65.2,17.839a.621.621,0,0,1-.5.982Z"
                    transform="translate(-29.958 -0.002)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="0"
                />
                <path
                    id="Path_127"
                    data-name="Path 127"
                    d="M28.664,39.3A8.136,8.136,0,1,1,36.8,31.162,8.146,8.146,0,0,1,28.664,39.3Zm0-15.03a6.894,6.894,0,1,0,6.894,6.894A6.9,6.9,0,0,0,28.664,24.269Z"
                    transform="translate(-2.321 -6.549)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="0"
                />
                <path
                    id="Path_128"
                    data-name="Path 128"
                    d="M26.333,75.717a.622.622,0,0,1-.543-.921l1.48-2.686a.621.621,0,1,1,1.088.6L26.877,75.4A.62.62,0,0,1,26.333,75.717Z"
                    transform="translate(-6.074 -41.852)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="0"
                />
                <path
                    id="Path_129"
                    data-name="Path 129"
                    d="M66.534,75.715a.621.621,0,0,1-.544-.322l-1.48-2.686a.621.621,0,1,1,1.088-.6l1.48,2.686a.622.622,0,0,1-.544.921Z"
                    transform="translate(-34.106 -41.85)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="0"
                />
            </g>
        </svg>
    );
};

export const AccountSecurityIcon = () => {
    return (
        <svg width="20.583" height="29.404" viewBox="0 0 20.583 29.404">
            <g id="Group_110" data-name="Group 110" transform="translate(-5 -2.005)">
                <path
                    id="Path_92"
                    data-name="Path 92"
                    d="M19.7,13.766H10.881V9.356a4.411,4.411,0,0,1,8.821,0Zm-2.94,9.883V27h-2.94V23.649a2.94,2.94,0,1,1,2.94,0Zm5.881-9.883V9.356a7.351,7.351,0,1,0-14.7,0v4.411A2.941,2.941,0,0,0,5,16.707V28.468a2.941,2.941,0,0,0,2.94,2.94h14.7a2.941,2.941,0,0,0,2.94-2.94V16.707A2.941,2.941,0,0,0,22.642,13.766Z"
                    transform="translate(0 0)"
                    fill="#b2b2b2"
                    fillRule="evenodd"
                />
            </g>
        </svg>
    );
};

export const DeleteImageIcon = () => {
    return (
        <svg width="23.056" height="23.056" viewBox="0 0 17.056 17.056">
            <path
                id="Path_142"
                data-name="Path 142"
                d="M5.711,14.37a1.425,1.425,0,0,0,1.421,1.421h5.685a1.425,1.425,0,0,0,1.421-1.421V5.843H5.711Zm9.238-10.66H12.462L11.751,3H8.2l-.711.711H5V5.132h9.949Z"
                transform="translate(-1.447 -0.868)"
                fill="#fff"
            />
            <path id="Path_143" data-name="Path 143" d="M0,0H17.056V17.056H0Z" fill="none" />
        </svg>
    );
};

export const EditPostIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24">
            <path
                fill="#fff"
                d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>
    );
};

export const DeletePostIcon = () => {
    return (
        <svg width="13.084" height="16.415" viewBox="0 0 13.084 16.415">
            <g id="Group_203" data-name="Group 203" transform="translate(-35.948 -32.371)">
                <g id="Group_202" data-name="Group 202" transform="translate(35.948 32.371)">
                    <path
                        id="Path_131"
                        data-name="Path 131"
                        d="M35.968,26.073l-.441,11.9a.4.4,0,0,1-.393.377H27.522a.4.4,0,0,1-.393-.377l-.441-11.9a.595.595,0,1,0-1.189.044l.441,11.9a1.591,1.591,0,0,0,1.581,1.523h7.613a1.59,1.59,0,0,0,1.581-1.523l.441-11.9a.595.595,0,1,0-1.189-.044Z"
                        transform="translate(-24.787 -23.121)"
                        fill="#fff"
                    />
                    <path
                        id="Path_132"
                        data-name="Path 132"
                        d="M48,36.476v8.088a.476.476,0,0,0,.952,0V36.476a.476.476,0,0,0-.952,0Z"
                        transform="translate(-41.934 -31.123)"
                        fill="#fff"
                    />
                    <path
                        id="Path_133"
                        data-name="Path 133"
                        d="M37,36.49l.238,8.088a.476.476,0,1,0,.951-.028l-.238-8.088A.476.476,0,1,0,37,36.49Z"
                        transform="translate(-33.551 -31.123)"
                        fill="#fff"
                    />
                    <path
                        id="Path_134"
                        data-name="Path 134"
                        d="M58.238,36.462,58,44.55a.476.476,0,0,0,.951.028l.238-8.088a.476.476,0,1,0-.951-.028Z"
                        transform="translate(-49.555 -31.123)"
                        fill="#fff"
                    />
                    <path
                        id="Path_135"
                        data-name="Path 135"
                        d="M23.095,25.189H34.99a.595.595,0,1,0,0-1.189H23.095a.595.595,0,0,0,0,1.189Z"
                        transform="translate(-22.5 -21.978)"
                        fill="#fff"
                    />
                    <path
                        id="Path_136"
                        data-name="Path 136"
                        d="M38.74,17.923l.248-.867a.576.576,0,0,1,.487-.367H41.62a.576.576,0,0,1,.487.367l.248.867L43.5,17.6l-.248-.867A1.758,1.758,0,0,0,41.62,15.5H39.474a1.758,1.758,0,0,0-1.631,1.23L37.6,17.6Z"
                        transform="translate(-34.005 -15.5)"
                        fill="#fff"
                    />
                </g>
            </g>
        </svg>
    );
};

export const DeletePostModalIcon = () => {
    return (
        <svg width="45.636" height="57.253" viewBox="0 0 45.636 57.253">
            <g id="Group_203" data-name="Group 203" transform="translate(-149.948 -22.371)">
                <g id="Group_202" data-name="Group 202" transform="translate(149.948 22.371)">
                    <path
                        id="Path_131"
                        data-name="Path 131"
                        d="M62.011,27.5,60.474,68.991A1.4,1.4,0,0,1,59.1,70.306H32.553a1.4,1.4,0,0,1-1.369-1.315L29.647,27.5a2.074,2.074,0,1,0-4.145.154l1.537,41.493a5.548,5.548,0,0,0,5.515,5.31H59.1a5.546,5.546,0,0,0,5.515-5.31l1.537-41.493a2.074,2.074,0,0,0-4.145-.154Z"
                        transform="translate(-23.011 -17.203)"
                        fill="#6da3fa"
                    />
                    <path
                        id="Path_132"
                        data-name="Path 132"
                        d="M48,37.659V65.871a1.66,1.66,0,1,0,3.319,0V37.659a1.66,1.66,0,0,0-3.319,0Z"
                        transform="translate(-26.841 -18.99)"
                        fill="#6da3fa"
                    />
                    <path
                        id="Path_133"
                        data-name="Path 133"
                        d="M37,37.708l.83,28.211a1.659,1.659,0,0,0,3.317-.1l-.83-28.211a1.659,1.659,0,1,0-3.317.1Z"
                        transform="translate(-24.969 -18.99)"
                        fill="#6da3fa"
                    />
                    <path
                        id="Path_134"
                        data-name="Path 134"
                        d="M58.831,37.611,58,65.822a1.659,1.659,0,0,0,3.317.1l.83-28.211a1.659,1.659,0,1,0-3.317-.1Z"
                        transform="translate(-28.544 -18.99)"
                        fill="#6da3fa"
                    />
                    <path
                        id="Path_135"
                        data-name="Path 135"
                        d="M24.574,28.149H66.062a2.074,2.074,0,0,0,0-4.149H24.574a2.074,2.074,0,1,0,0,4.149Z"
                        transform="translate(-22.5 -16.947)"
                        fill="#6da3fa"
                    />
                    <path
                        id="Path_136"
                        data-name="Path 136"
                        d="M41.585,23.953l.864-3.024a2.01,2.01,0,0,1,1.7-1.28H51.63a2.009,2.009,0,0,1,1.7,1.28l.864,3.024,3.989-1.14-.864-3.023A6.13,6.13,0,0,0,51.63,15.5H44.147a6.131,6.131,0,0,0-5.687,4.29L37.6,22.813Z"
                        transform="translate(-25.07 -15.5)"
                        fill="#6da3fa"
                    />
                </g>
            </g>
        </svg>
    );
};

export const HideQuestionButtonIcon = () => {
    return (
        <svg width="99" height="23" viewBox="0 0 99 23">
            <defs>
                <clip-path id="clip-path">
                    <rect width="99" height="23" fill="none" />
                </clip-path>
            </defs>
            <g id="Group_208" data-name="Group 208" transform="translate(-911 -1777)">
                <g id="Group_268" data-name="Group 268">
                    <g
                        id="Component_1_1"
                        data-name="Component 1 – 1"
                        transform="translate(911 1777)"
                        clipPath="url(#clip-path)"
                    >
                        <path
                            id="Rectangle_195"
                            data-name="Rectangle 195"
                            d="M11,0H88A11,11,0,0,1,99,11V23a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V11A11,11,0,0,1,11,0Z"
                            fill="#e5e5e5"
                            opacity="0.558"
                        />
                        <path
                            id="Path_95"
                            data-name="Path 95"
                            d="M2073.4,4929.814l6.622,5.3,6.783-5.3"
                            transform="translate(2129.238 4944.938) rotate(-180)"
                            fill="none"
                            stroke="#a7a7a7"
                            strokeLinecap="round"
                            strokeWidth="2"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const ContactIcon = () => {
    return (
        <svg width="44.227" height="78.26" viewBox="0 0 44.227 78.26">
            <g id="Group_394" data-name="Group 394" transform="translate(-876.809 -380.818)">
                <g id="Group_284" data-name="Group 284" transform="translate(13.46 -4696.182)">
                    <circle
                        id="Ellipse_104"
                        data-name="Ellipse 104"
                        cx="20.734"
                        cy="20.734"
                        r="20.734"
                        transform="translate(864.494 5077)"
                        fill="#77a9fa"
                    />
                    <g id="Group_283" data-name="Group 283" transform="translate(863.349 5077.193)">
                        <g id="Group_282" data-name="Group 282" transform="translate(0 0)">
                            <path
                                id="Path_164"
                                data-name="Path 164"
                                d="M-14858.687,6001.794s-49.266-67.375-.232-78.029C-14858.232,5962.369-14858.687,6001.794-14858.687,6001.794Z"
                                transform="translate(14880.652 -5923.766)"
                                fill="#77a9fa"
                            />
                            <path
                                id="Path_165"
                                data-name="Path 165"
                                d="M-14877.971,6001.833s50.215-67.584,0-78.067C-14878.658,5962.369-14877.971,6001.833-14877.971,6001.833Z"
                                transform="translate(14899.879 -5923.766)"
                                fill="#77a9fa"
                            />
                        </g>
                        <circle
                            id="Ellipse_105"
                            data-name="Ellipse 105"
                            cx="12.5"
                            cy="12.5"
                            r="12.5"
                            transform="translate(9.596 9.985)"
                            fill="#fff"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const AboutIcon = () => {
    return (
        <svg width="85" height="85" xmlns="http://www.w3.org/2000/svg">
            <g>
                <title>background</title>
                <rect fill="none" id="canvas_background" height="402" width="582" y="-1" x="-1" />
            </g>
            <g>
                <title>Layer 1</title>
                <path
                    fill="#ffffff"
                    id="svg_1"
                    d="m42.5,0.003c-23.472,0 -42.5,19.028 -42.5,42.5s19.028,42.5 42.5,42.5s42.5,-19.027 42.5,-42.5s-19.028,-42.5 -42.5,-42.5zm-0.212,66.267c0,0 -1.972,1.311 -3.32,1.305c-0.12,0.055 -0.191,0.087 -0.191,0.087l0.003,-0.087c-0.283,-0.013 -0.568,-0.053 -0.855,-0.125l-0.426,-0.105c-2.354,-0.584 -3.6,-2.918 -3.014,-5.271l3.277,-13.211l1.479,-5.967c1.376,-5.54 -4.363,1.178 -5.54,-1.374c-0.777,-1.687 4.464,-5.227 8.293,-7.896c0,0 1.97,-1.309 3.319,-1.304c0.121,-0.056 0.192,-0.087 0.192,-0.087l-0.005,0.087c0.285,0.013 0.57,0.053 0.857,0.124l0.426,0.106c2.354,0.584 3.788,2.965 3.204,5.318l-3.276,13.212l-1.482,5.967c-1.374,5.54 4.27,-1.204 5.446,1.351c0.777,1.685 -4.559,5.201 -8.387,7.87zm8.306,-41.294c-0.818,3.295 -4.152,5.304 -7.446,4.486c-3.296,-0.818 -5.305,-4.151 -4.487,-7.447c0.818,-3.296 4.152,-5.304 7.446,-4.486c3.296,0.817 5.304,4.151 4.487,7.447z"
                />
            </g>
        </svg>
    );
};

export const MobileNavIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24.582"
            height="21.41"
            viewBox="0 0 24.582 21.41"
        >
            <g id="Groupe_256" data-name="Groupe 256" transform="translate(-321 -29)">
                <rect
                    id="Rectangle_224"
                    data-name="Rectangle 224"
                    width="24.582"
                    height="3.965"
                    transform="translate(321 29)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_225"
                    data-name="Rectangle 225"
                    width="24.582"
                    height="3.965"
                    transform="translate(321 37.723)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_226"
                    data-name="Rectangle 226"
                    width="24.582"
                    height="3.965"
                    transform="translate(321 46.445)"
                    fill="#fff"
                />
            </g>
        </svg>
    );
};

export const MobileNavCloseIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21.41"
            height="24.582"
            viewBox="0 0 21.41 24.582"
        >
            <g id="Groupe_256" data-name="Groupe 256" transform="translate(50.41 -321) rotate(90)">
                <rect
                    id="Rectangle_224"
                    data-name="Rectangle 224"
                    width="24.582"
                    height="3.965"
                    transform="translate(321 29)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_225"
                    data-name="Rectangle 225"
                    width="24.582"
                    height="3.965"
                    transform="translate(321 37.723)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_226"
                    data-name="Rectangle 226"
                    width="24.582"
                    height="3.965"
                    transform="translate(321 46.445)"
                    fill="#fff"
                />
            </g>
        </svg>
    );
};

export const LogOutIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29.038"
            height="29.038"
            viewBox="0 0 29.038 29.038"
        >
            <g
                id="Grupo_576"
                data-name="Grupo 576"
                transform="translate(1622.193 63.202) rotate(180)"
            >
                <g id="Grupo_574" data-name="Grupo 574" transform="translate(342.664 -174.336)">
                    <g id="Grupo_343" data-name="Grupo 343" transform="translate(1250.491 208.5)">
                        <g
                            id="Elipse_100"
                            data-name="Elipse 100"
                            fill="none"
                            stroke="#fff"
                            strokeWidth="2"
                        >
                            <circle cx="14.519" cy="14.519" r="14.519" stroke="none" />
                            <circle cx="14.519" cy="14.519" r="13.519" fill="none" />
                        </g>
                    </g>
                </g>
                <g id="Grupo_575" data-name="Grupo 575" transform="translate(1596.695 38.055)">
                    <g id="Grupo_135" data-name="Grupo 135" transform="translate(3.221 5.615)">
                        <g id="Grupo_134" data-name="Grupo 134">
                            <g id="Grupo_133" data-name="Grupo 133" transform="translate(0 0)">
                                <path
                                    id="Trazado_107"
                                    data-name="Trazado 107"
                                    d="M9.893,21.792a.9.9,0,0,1,0-1.792H21.1a.9.9,0,0,1,0,1.792Z"
                                    transform="translate(-9 -15.566)"
                                    fill="#fff"
                                    fillRule="evenodd"
                                />
                                <path
                                    id="Trazado_108"
                                    data-name="Trazado 108"
                                    d="M32.964,16.064,28.529,20.5a.9.9,0,0,1-1.267-1.267l3.8-3.8-3.8-3.8a.9.9,0,0,1,1.267-1.267L32.964,14.8A.9.9,0,0,1,32.964,16.064Z"
                                    transform="translate(-18.938 -10.1)"
                                    fill="#fff"
                                    fillRule="evenodd"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const CreateTeamsIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34.195"
            height="34.195"
            viewBox="0 0 34.195 34.195"
        >
            <g id="Groupe_596" data-name="Groupe 596" transform="translate(-72.902 -471.902)">
                <g id="group_work-24px" transform="translate(72.902 471.902)">
                    <path
                        id="Tracé_199"
                        data-name="Tracé 199"
                        d="M0,0H34.2V34.2H0Z"
                        fill="none"
                        stroke="none"
                    />
                    <path
                        id="Tracé_200"
                        data-name="Tracé 200"
                        d="M16.248,2A14.248,14.248,0,1,0,30.5,16.248,14.253,14.253,0,0,0,16.248,2Zm-5.7,22.084a3.562,3.562,0,1,1,3.562-3.562A3.563,3.563,0,0,1,10.549,24.084Zm2.137-13.536a3.562,3.562,0,1,1,3.562,3.562A3.563,3.563,0,0,1,12.686,10.549Zm9.261,13.536a3.562,3.562,0,1,1,3.562-3.562A3.563,3.563,0,0,1,21.947,24.084Z"
                        transform="translate(0.85 0.85)"
                        fill="#fff"
                        stroke="none"
                    />
                </g>
            </g>
        </svg>
    );
};

export const InviteFriendsIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29.038"
            height="29.038"
            viewBox="0 0 29.038 29.038"
        >
            <g id="Groupe_597" data-name="Groupe 597" transform="translate(-114.156 -249.164)">
                <g id="Groupe_444" data-name="Groupe 444" transform="translate(-1136.335 40.664)">
                    <g id="Groupe_343" data-name="Groupe 343" transform="translate(1250.491 208.5)">
                        <g
                            id="Ellipse_100"
                            data-name="Ellipse 100"
                            fill="none"
                            stroke="#fff"
                            strokeWidth="2"
                        >
                            <circle cx="14.519" cy="14.519" r="14.519" stroke="none" />
                            <circle cx="14.519" cy="14.519" r="13.519" fill="none" />
                        </g>
                    </g>
                </g>
                <circle
                    id="Ellipse_129"
                    data-name="Ellipse 129"
                    cx="5.5"
                    cy="5.5"
                    r="5.5"
                    transform="translate(123 258)"
                    fill="#fff"
                />
                <path
                    id="Tracé_303"
                    data-name="Tracé 303"
                    d="M-14201.919,1232.395c-8.062,10.672-15.963,1.563-16.726,0"
                    transform="translate(14339 -965)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeWidth="3"
                />
            </g>
        </svg>
    );
};

export const AccountSettingsIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29.038"
            height="29.038"
            viewBox="0 0 29.038 29.038"
        >
            <g id="Groupe_598" data-name="Groupe 598" transform="translate(-114.156 -302.164)">
                <g id="build-24px" transform="translate(117 307)">
                    <path
                        id="Tracé_197"
                        data-name="Tracé 197"
                        d="M0,0H22V22H0Z"
                        fill="none"
                        stroke="none"
                    />
                    <path
                        id="Tracé_198"
                        data-name="Tracé 198"
                        d="M15.817,13.334,9.6,7.115A4.387,4.387,0,0,0,8.573,2.4,4.518,4.518,0,0,0,3.515,1.51L6.454,4.449,4.4,6.5,1.4,3.56a4.4,4.4,0,0,0,.889,5.058A4.387,4.387,0,0,0,7,9.643l6.22,6.22a.661.661,0,0,0,.957,0l1.572-1.572a.616.616,0,0,0,.068-.957Z"
                        transform="translate(2.489 1.462)"
                        fill="#fff"
                        stroke="none"
                    />
                </g>
                <g id="Groupe_444" data-name="Groupe 444" transform="translate(-1136.335 93.664)">
                    <g id="Groupe_343" data-name="Groupe 343" transform="translate(1250.491 208.5)">
                        <g
                            id="Ellipse_100"
                            data-name="Ellipse 100"
                            fill="none"
                            stroke="none"
                            strokeWidth="0"
                        >
                            <circle cx="14.519" cy="14.519" r="14.519" stroke="none" />
                            <circle cx="14.519" cy="14.519" r="13.519" fill="none" stroke="none" />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const InviteIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="41" height="45" viewBox="0 0 41 45">
            <g id="Groupe_571" data-name="Groupe 571" transform="translate(-307 -1748)">
                <g id="Groupe_124" data-name="Groupe 124" transform="translate(5 872)">
                    <path
                        id="Tracé_93"
                        data-name="Tracé 93"
                        d="M23,11.5a11.5,11.5,0,0,1-23,0C0,5.149,23,5.149,23,11.5Z"
                        transform="translate(325 916.737) rotate(180)"
                        fill="#77a9fa"
                        stroke="none"
                    />
                    <g
                        id="Ellipse_74"
                        data-name="Ellipse 74"
                        transform="translate(308 883)"
                        fill="#77a9fa"
                        strokeWidth="0"
                        stroke="none"
                    >
                        <circle cx="5.5" cy="5.5" r="5.5" stroke="none" />
                        <circle cx="5.5" cy="5.5" r="7" stroke="none" fill="none" />
                    </g>
                </g>
                <text
                    id="_"
                    data-name="+"
                    transform="translate(318 1748)"
                    fill="#77a9fa"
                    fontSize="22"
                    fontFamily="HelveticaNeue-Bold, Helvetica Neue"
                    fontWeight="700"
                >
                    <tspan x="8.4" y="21">
                        +
                    </tspan>
                </text>
            </g>
        </svg>
    );
};

export const DashboardIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29.038"
            height="29.038"
            viewBox="0 0 29.038 29.038"
        >
            <g id="Groupe_599" data-name="Groupe 599" transform="translate(-114.156 -302.164)">
                <g id="Groupe_444" data-name="Groupe 444" transform="translate(-1136.335 93.664)">
                    <g id="Groupe_343" data-name="Groupe 343" transform="translate(1250.491 208.5)">
                        <g
                            id="Ellipse_100"
                            data-name="Ellipse 100"
                            fill="none"
                            stroke="#fff"
                            strokeWidth="2"
                        >
                            <circle cx="14.519" cy="14.519" r="14.519" stroke="none" />
                            <circle cx="14.519" cy="14.519" r="13.519" fill="none" />
                        </g>
                    </g>
                </g>
                <rect
                    id="Rectangle_303"
                    data-name="Rectangle 303"
                    width="12"
                    height="8"
                    transform="translate(123 316)"
                    fill="#fff"
                />
                <path
                    id="Polygone_1"
                    data-name="Polygone 1"
                    d="M9,0l9,7H0Z"
                    transform="translate(120 308)"
                    fill="#fff"
                />
            </g>
        </svg>
    );
};

export const BackIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="33.509" height="25" viewBox="0 0 33.509 25">
            <g id="Groupe_570" data-name="Groupe 570" transform="translate(1572.718 -1.184)">
                <g
                    id="Groupe_135"
                    data-name="Groupe 135"
                    transform="translate(-1539.209 26.184) rotate(180)"
                >
                    <g id="Groupe_134" data-name="Groupe 134" transform="translate(0 0)">
                        <g id="Groupe_133" data-name="Groupe 133">
                            <path
                                id="Tracé_107"
                                data-name="Tracé 107"
                                d="M2.094,4.2a2.1,2.1,0,0,1,0-4.2H28.369a2.1,2.1,0,0,1,0,4.2Z"
                                transform="translate(0 10.399)"
                                fill="#fff"
                                fillRule="evenodd"
                            />
                            <path
                                id="Tracé_108"
                                data-name="Tracé 108"
                                d="M13.985,13.985l-10.4,10.4A2.1,2.1,0,0,1,.615,21.413L9.528,12.5.615,3.587A2.1,2.1,0,0,1,3.586.615l10.4,10.4A2.1,2.1,0,0,1,13.985,13.985Z"
                                transform="translate(18.908)"
                                fill="#fff"
                                fillRule="evenodd"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};
